import Swiper from "swiper";
import { Navigation } from "swiper/modules";
import "swiper/css";

export default function initMenuSwiper() {
  const containers = document.querySelectorAll(".menu-swiper-container");

  if (!containers.length) return;

  containers.forEach((container) => {
    const swiperEl = container.querySelector(".menu-swiper");
    const prevButton = container.querySelector(".carousel-button-prev");
    const nextButton = container.querySelector(".carousel-button-next");
    const progressBar = container.querySelector(".carousel-progress-bar");
    const controls = container.querySelector(".carousel-controls");

    if (!swiperEl) return;

    function updateProgressBar(swiper) {
      if (!progressBar) return;
      const total = swiper.slides.length;
      const perView =
        typeof swiper.params.slidesPerView === "number"
          ? swiper.params.slidesPerView
          : 1;
      const visible = Math.min(perView / total, 1);
      const scrollProgress = Math.min(Math.max(swiper.progress, 0), 1);
      const progress = (visible + scrollProgress * (1 - visible)) * 100;
      progressBar.style.width = `${Math.min(progress, 100)}%`;
    }

    function updateControlsVisibility(swiper) {
      if (!controls) return;
      const slidesPerView = swiper.params.slidesPerView;
      const totalSlides = swiper.slides.length;

      if (totalSlides <= slidesPerView) {
        controls.style.display = "none";
      } else {
        controls.style.display = "";
      }
    }

    new Swiper(swiperEl, {
      modules: [Navigation],
      slidesPerView: 1.5,
      spaceBetween: 8,
      navigation: {
        prevEl: prevButton,
        nextEl: nextButton,
      },
      breakpoints: {
        768: {
          slidesPerView: 2.5,
        },
        1024: {
          slidesPerView: 3.5,
        },
      },
      on: {
        init: function () {
          updateProgressBar(this);
          updateControlsVisibility(this);
        },
        slideChange: function () {
          updateProgressBar(this);
        },
        progress: function () {
          updateProgressBar(this);
        },
        resize: function () {
          updateProgressBar(this);
          updateControlsVisibility(this);
        },
      },
    });
  });
}
